import { simpleMastheadFragment } from 'humanity/sections/simpleMasthead';

/**
 * @type {String}
 */
export const retirementGlossaryFragment = `
  ... on PageContentRetirementGlossary {
    sectionsCollection (limit: 10) {
      items {
        ${simpleMastheadFragment}
      }
    }
  }
`;
